import React from 'react';
import PropTypes from 'prop-types';
import './Cell.sass'

Cell.propTypes = {
    children: PropTypes.any
};

function Cell({children, title}) {
    return (
        <div title={title} className={'row__cell'}>
            {children}
        </div>
    );
}

export default Cell;